import { render, staticRenderFns } from "./DashboardBtn.vue?vue&type=template&id=30755c4c"
import script from "./DashboardBtn.js?vue&type=script&lang=js&external"
export * from "./DashboardBtn.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports